import general from '../../utils/general';
import { useState, useRef, useEffect } from 'react';
import { LanguageKeys } from './translation';

export const useController = () => {
    const [currentLanguage, setCurrentLanguage] = useState<LanguageKeys>(general?.getAccount()?.preferredLanguage ?? 'EN');
    const [buttonClicked, setButtonClicked] = useState(false);

    const getCheckoutSession = async () => {
        try {
            setButtonClicked(true);
            if (buttonClicked) {
                console.warn('Checkout session already in progress.');
                return;
            }
            const response = await general.api.post('/stripe/create/checkout', {
                priceId: process.env.REACT_APP_STRIPE_PRICE_ID,
            }).then(res => {
                if (res.data.status === 200) {
                    window.location.href = res.data.data.url;
                } else {
                    setButtonClicked(false);
                    console.error('Error creating checkout session:', res.data.message);
                }
            });
        } catch (error) {
            console.error('Error fetching checkout session:', error);
            setButtonClicked(false);
            throw error;
        }
    }

    return {
        general,
        currentLanguage,
        buttonClicked,
        setButtonClicked,
        setCurrentLanguage,
        getCheckoutSession,
    };
}

export default useController;